import { render } from "./vluckydrawrecordadd.vue?vue&type=template&id=58c6b61d&scoped=true"
import script from "./vluckydrawrecordadd.vue?vue&type=script&lang=js"
export * from "./vluckydrawrecordadd.vue?vue&type=script&lang=js"

import "./vluckydrawrecordadd.vue?vue&type=style&index=0&id=58c6b61d&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58c6b61d"]])

export default __exports__